import { AfterViewInit, Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ManageType } from 'src/app/decorators/type-manager-decorator';
import { CNConsultation, CNConsultationType } from 'src/app/models/cnconsultation';
import { CNServiceCode } from 'src/app/models/cnservicecode';
import { SNUser } from 'src/app/models/snuser';
import { ContactService } from 'src/app/services/contact.service';
import { ServicesService } from 'src/app/services/services.service';
import { UserConfigService } from 'src/app/services/user-config.service';

@ManageType('ContactServicesDialogComponent')
@Component({
  selector: 'app-contact-services-dialog',
  templateUrl: './contact-services-dialog.component.html',
  styleUrls: ['./contact-services-dialog.component.scss']
})
export class ContactServicesDialogComponent implements OnInit, AfterViewInit {

  public contact: CNConsultation;
  public user: SNUser;

  constructor(private dialog: MatDialog, private dialogRef: MatDialogRef<ContactServicesDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any, public userConfig: UserConfigService,
              private contactSrv: ContactService, private servicesSrv: ServicesService) {
    if (data && data.contact) {
      this.contact = data.contact;
    }
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    if (!this.user) {
      this.user = this.userConfig.user;
      this.contactSrv.loadContactTypes(this.user);
      this.servicesSrv.loadCodesGroups(this.user);
    }
  }

  selectType(type: CNConsultationType) {
    // this.contactComponentRef.type = type;
    // this.userOpenItems.setItemType(this.contact, type);
    // this.servicesSrv.loadContactRules(type);
  }

  selectUser(user: SNUser) {
    this.user = user;
    this.contact.healthagentid = this.user.id;
    this.contactSrv.loadContactTypes(user);
    this.servicesSrv.loadCodesGroups(user);
  }

  codeAction(action: [action: string, code: CNServiceCode | CNServiceCode[]]): void {
    console.log('code action', action);
    switch (action[0]) {
      case 'add':
        {
          if (Array.isArray(action[1])) {
            action[1].forEach(aCode => {
              this.contact.addServiceCode(aCode);
            });
          } else {
            this.contact.addServiceCode(action[1]);
          }
        }
        break;
      case 'delete':
        {
          if (!Array.isArray(action[1])) {
            this.contact.removeServiceCode(action[1]);
          }
        }
        break;
    }
  }

  close() {
    this.dialogRef.close();
  }

  save() {
    this.dialogRef.close(this.contact);
  }

}
